module.exports = __webpack_public_path__ + "img/isPro3_2.05b618ab.png";